<p>demokratiewerkstatt-category-detail works!</p>
